import getStaffInfo from './module/taskModule/staff'
import getOperatorCancelReasonInfo from './module/taskModule/operatorCancelReason'
import getOperatorCancelHistoryInfo from './module/taskModule/operatorCancelHistory'
import getCaseDelayInfo from './module/taskModule/caseDelayInfo'

import getInjuredInfo from './module/basicModule/injuredInfo'
import getInjuryInfo from './module/basicModule/injuryInfo'
import getAccidentInfo from './module/basicModule/accidentInfo'

import getCaregiversInfo from './module/socialModule/caregiversInfo'
import getWorkInfo from './module/socialModule/workInfo'
import getLivingInfo from './module/socialModule/livingInfo'
import getFamilyInfo from './module/socialModule/familyInfo'
import getAgentInfo from './module/socialModule/agentInfo'

import getImageInfo from './module/imageModule/imageInfo'

import getInjuredRecord from './module/investigateModule/injuredRecord'
import getCompanyRecord from './module/investigateModule/companyRecord'
import getLandlordRecord from './module/investigateModule/landlordRecord'
import getCommitteeRecord from './module/investigateModule/committeeRecord'
import getInvestigateImageInfo from './module/investigateModule/imageInfo.js'

import getMediateCarOwner from './module/mediateModule/carOwnerInfo'
import getMediateInjured from './module/mediateModule/injuredInfo'
import getMediateImageInfo from './module/mediateModule/imageInfo.js'
import getAgreementsInfo from './module/mediateModule/agreementsInfo.js'
import getCostTableInfo from './module/mediateModule/costTableInfo.js'

import getLawyerInfo from './module/lawsuitModule/lawyerInfo'
import getCaseInfo from './module/lawsuitModule/caseInfo'
import getResultInfo from './module/lawsuitModule/resultInfo'

import getHospitalized from './module/homeInvestigateModule/hospitalized'
import getHomeInjuredInfo from './module/homeInvestigateModule/injuredInfo'
import getMediate from './module/homeInvestigateModule/mediate'
import getHomeImageInfo from './module/homeInvestigateModule/imageInfo'

import getOtherInvestigateImageInfo from './module/otherInvestigateModule/imageInfo'
import getTaskInfo from './module/commonModule/taskInfo'
import getAnamnesisInfo from './module/paicModule/anamnesisInfo'
import getBeneficiaryInfo from './module/paicModule/beneficiaryInfo'
import getCertificateInfo from './module/paicModule/certificateInfo'
import getMajorDiseaseInfo from './module/paicModule/majorDiseaseInfo'

// 可编辑数据
import getEditInjuredInfo from './module/editModule/editInjuredInfo'
import getEditInjuryInfo from './module/editModule/editInjuryInfo'
import getEditAccidentInfo from './module/editModule/editAccidentInfo'
import getEditSubAccidentInfo from './module/editModule/editSubAccidentInfo'
import getEditRemarkInfo from './module/editModule/editRemarkInfo'
import getEditCertificateInfo from './module/editModule/editCertificateInfo'
import getEditBeneficiaryInfo from './module/editModule/editBeneficiaryInfo'
import getEditDiagnoseInfo from './module/editModule/editDiagnoseInfo'
import getEditFamilyInfo from './module/editModule/editFamilyInfo'
import getEditCaregiversInfo from './module/editModule/editCaregiversInfo'
import getEditWorkInfo from './module/editModule/editWorkInfo'
import getEditLivingInfo from './module/editModule/editLivingInfo'
import getEditMajorDiseaseInfo from './module/editModule/editMajorDiseaseInfo'
import getEditAnamnesisInfo from './module/editModule/editAnamnesisInfo'

import { initOrderDetail } from './utils/order'
import Vue from 'vue'
import taskMixin from './task'

const investigateFuncs = {
	getInjuredRecord,
	getCompanyRecord,
	getLandlordRecord,
	getCommitteeRecord,
	getInvestigateImageInfo,
}

const mediateFuncs = {
	getMediateCarOwner,
	getMediateInjured,
	getMediateImageInfo,
	getAgreementsInfo,
	getCostTableInfo,
}

const lawyerFuncs = {
	getLawyerInfo,
	getCaseInfo,
	getResultInfo,
}

const otherInvestigateFuncs = {
	getOtherInvestigateImageInfo,
}

const homeInvestigateFuncs = {
	getHospitalized,
	getHomeInjuredInfo,
	getMediate,
	getHomeImageInfo,
}

const paicFuncs = {
	getAnamnesisInfo,
	getBeneficiaryInfo,
	getCertificateInfo,
	getMajorDiseaseInfo,
}
const getEditInfoFuncs = {
	getEditInjuredInfo,
	getEditInjuryInfo,
	getEditAccidentInfo,
	getEditSubAccidentInfo,
	getEditRemarkInfo,
	getEditCertificateInfo,
	getEditBeneficiaryInfo,
	getEditDiagnoseInfo,
	getEditFamilyInfo,
	getEditCaregiversInfo,
	getEditWorkInfo,
	getEditLivingInfo,
	getEditMajorDiseaseInfo,
	getEditAnamnesisInfo,
}

const ins = {
	mixins: [taskMixin],
	methods: {
		getTaskInfo,
		getStaffInfo,
		getInjuredInfo,
		getInjuryInfo,
		getAccidentInfo,
		getCaregiversInfo,
		getWorkInfo,
		getLivingInfo,
		getFamilyInfo,
		getAgentInfo,
		getOperatorCancelReasonInfo,
		getOperatorCancelHistoryInfo,
		getImageInfo,
		...investigateFuncs,
		initOrderDetail,
		...mediateFuncs,
		...lawyerFuncs,
		...otherInvestigateFuncs,
		...homeInvestigateFuncs,
		getCaseDelayInfo,
		...paicFuncs,
		...getEditInfoFuncs,
	},
}

// const RS_SERIALIZE = Vue.extend(ins)

export default Vue.extend(ins)

// window.RS_SERIALIZE = RS_SERIALIZE
